import { erpEquivalenciesTypes } from './types';

const {
  HANDLE_ERP_EQUIVALENCIES_INPUTS,
  GET_ERP_EQUIVALENCIES,
  GET_BANK_REFERENCES,
  GET_DATA_FISCAL,
  GET_SHIP_TO_ADDRESS,
  GET_CREDIT_CONDITIONS,
  RESTORE_INITIAL
} = erpEquivalenciesTypes;

const initialState = {
  erpEquivalencies: [],
  bankReference: null,
  fiscalData: null,
  station: null,
  shipToAddress: {},
  creditConditions: {},
};

export const erpEquivalenciesReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case HANDLE_ERP_EQUIVALENCIES_INPUTS:
      return {
        ...state,
        [payload.key]: payload.value
      };
    case GET_ERP_EQUIVALENCIES:
      return { ...state, erpEquivalencies: payload };
    case GET_BANK_REFERENCES:
      return { ...state, bankReference: payload };
    case GET_DATA_FISCAL:
      return { ...state, fiscalData: payload };
    case GET_CREDIT_CONDITIONS: {
      const creditConditions = {
        billToCode: payload?.billTo?.code,
        billToAccount: payload?.customerAccountSiteNumber,
        isCreditNote: payload?.isCreditNote,
        discount: payload?.discount,
        isCreditSuspended: payload?.isCreditSuspended,
        suspensionDate: payload?.suspendedDate,
        availableCredit: payload?.creditAvailability,
        creditLimit: payload?.credit,
        creditDays: payload?.creditDays,
        discountType: payload?.discountType,
        isWholesaler: payload?.isWholesaler,
      };
      return { ...state, creditConditions };
    }
    case GET_SHIP_TO_ADDRESS:
      return { ...state, shipToAddress: payload};
    case RESTORE_INITIAL:
      return {
        ...initialState
      }
    default:
      return state;
  }
};